import React, { useState } from 'react';
import { CheckCircle, Circle, ArrowLeft } from 'lucide-react';
import { subjectColors } from '../utils/constants';
interface Achievement {
  id: string;
  text: string;
  completed: boolean;
}
interface Topic {
  title: string;
  achievements: Achievement[];
}
interface Subject {
  id: string;
  title: string;
  image: string;
  topics: Topic[];
}
const subjects: Subject[] = [{
  id: 'turkce',
  title: 'Türkçe',
  image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/53920870-2e72-4897-9a68-0d2901d601e4/image_fx__(5).jpg',
  topics: [{
    title: 'Sözcükte Anlam',
    achievements: [{
      id: 'sa1',
      text: 'Kelimeleri anlamlarına uygun kullanır.',
      completed: false
    }, {
      id: 'sa2',
      text: 'Bağlamdan yararlanarak bilmediği kelime ve kelime gruplarının anlamını tahmin eder.',
      completed: false
    }, {
      id: 'sa3',
      text: 'Yazıklarında yabancı dillerden alınmış, dilimize henüz yerleşmemiş kelimelerin Türkçelerini kullanır.',
      completed: false
    }]
  }, {
    title: 'Deyimler ve Atasözleri',
    achievements: [{
      id: 'da1',
      text: 'Deyim, atasözü ve özdeyişlerin metne katkısını belirler. Yazılarını zenginleştirmek için atasözleri, deyimler ve özdeyişler kullanır.',
      completed: false
    }]
  }, {
    title: 'Cümlede Anlam',
    achievements: [{
      id: 'ca1',
      text: 'Okuduklarıyla ilgili çıkarımlarda bulunur. (Neden-sonuç, amaç-sonuç, koşul, karşılaştırma, benzetme, örneklendirme, abartma, nesnel, öznel ve duygu belirten ifadeler üzerinde durulur.)',
      completed: false
    }]
  }, {
    title: 'Sözel Mantık / Görsel Okuma',
    achievements: [{
      id: 'sm1',
      text: 'Görsellerle ilgili soruları cevaplar.',
      completed: false
    }, {
      id: 'sm2',
      text: 'Görsellerden hareketle çıkarımlarda bulunur.',
      completed: false
    }]
  }, {
    title: 'Parçada Anlam',
    achievements: [{
      id: 'pa1',
      text: 'Metinde ortaya konan sorunlara farklı çözümler üretir.',
      completed: false
    }, {
      id: 'pa2',
      text: 'Metindeki anahtar kelimeleri belirler.',
      completed: false
    }, {
      id: 'pa3',
      text: 'Metinde önemli noktaların vurgulanması amacıyla kullanılan unsurları belirler.',
      completed: false
    }]
  }, {
    title: 'Söz Sanatları',
    achievements: [{
      id: 'ss1',
      text: 'Metindeki söz sanatlarını tespit eder. [Benzetme (teşbih), kişileştirme (teşhis), konuşturma (intak) ve karşıtlık (tezat), abartma (mübalağa) söz sanatlarının belirlenmesi sağlanır.]',
      completed: false
    }]
  }, {
    title: 'Metin Türleri',
    achievements: [{
      id: 'mt1',
      text: 'Metin türlerini ayırt eder.',
      completed: false
    }, {
      id: 'mt2',
      text: 'Şiir yazar.',
      completed: false
    }, {
      id: 'mt3',
      text: 'Bilgilendirici metin yazar.',
      completed: false
    }, {
      id: 'mt4',
      text: 'Hikâye edici metin yazar.',
      completed: false
    }, {
      id: 'mt5',
      text: 'Kısa metinler yazar. (Haber metni, günlük ve anı yazmaya teşvik edilir.)',
      completed: false
    }]
  }, {
    title: 'Noktalama İşaretleri',
    achievements: [{
      id: 'ni1',
      text: 'Noktalama işaretlerine dikkat ederek sesli ve sessiz okur.',
      completed: false
    }, {
      id: 'ni2',
      text: 'Yazıdıklarını düzenler. (Metinde yer alan yazım ve noktalama kuralları ile sınırlı tutulur.)',
      completed: false
    }]
  }, {
    title: 'Yazım Kuralları',
    achievements: [{
      id: 'yk1',
      text: 'Yazıdıklarını düzenler. (Metinde yer alan yazım ve noktalama kuralları ile sınırlı tutulur.)',
      completed: false
    }]
  }, {
    title: 'Fiilimsiler',
    achievements: [{
      id: 'f1',
      text: 'Fiilimsilerin cümledeki işlevlerini kavrar. (Fiilimsilerin türleri fark ettirilir, Ekler ezberletilmez.)',
      completed: false
    }]
  }, {
    title: 'Cümlenin Öğeleri',
    achievements: [{
      id: 'co1',
      text: 'Cümlenin ögelerini ayırt eder.',
      completed: false
    }]
  }, {
    title: 'Cümle Türleri',
    achievements: [{
      id: 'ct1',
      text: 'Cümle türlerini tanır. (Kavramsal tanımlamalara girilmez.)',
      completed: false
    }]
  }, {
    title: 'Anlatım Bozukluğu',
    achievements: [{
      id: 'ab1',
      text: 'Anlatım bozukluklarını tespit eder ve düzeltir.',
      completed: false
    }]
  }]
}, {
  id: 'matematik',
  title: 'Matematik',
  image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/472f13e1-d5a1-4908-a2f4-ca37914378a1/image_fx__(6).jpg',
  topics: [{
    title: 'Çarpanlar ve Katlar',
    achievements: [{
      id: 'ck1',
      text: 'Verilen pozitif tam sayıların çarpanlarını ve katlarını belirler.',
      completed: false
    }, {
      id: 'ck2',
      text: 'İki veya daha fazla doğal sayının en büyük ortak bölenini (EBOB) ve en küçük ortak katını (EKOK) hesaplar.',
      completed: false
    }]
  }, {
    title: 'Üslü Sayılar',
    achievements: [{
      id: 'us1',
      text: 'Tam sayıların, ondalık gösterimlerin ve rasyonel sayıların kuvvetlerini hesaplar.',
      completed: false
    }, {
      id: 'us2',
      text: 'Üslü sayılarla ilgili temel kuralları anlar ve uygular.',
      completed: false
    }]
  }, {
    title: 'Köklü Sayılar',
    achievements: [{
      id: 'ks1',
      text: 'Tam kare pozitif tam sayılarla işlemler yapar.',
      completed: false
    }, {
      id: 'ks2',
      text: 'Tam kare olmayan kareköklü bir sayının hangi iki doğal sayı arasında olduğunu belirler.',
      completed: false
    }]
  }, {
    title: 'Veri Analizi',
    achievements: [{
      id: 'va1',
      text: 'En fazla üç veri grubuna ait veri dağılımlarını karşılaştırmada ve yorumlamada aritmetik ortalama ve açıklığı kullanır.',
      completed: false
    }, {
      id: 'va2',
      text: 'Verileri sütun, daire veya çizgi grafiği ile gösterir ve bu gösterimler arasında uygun olan dönüşümleri yapar.',
      completed: false
    }]
  }, {
    title: 'Olasılık',
    achievements: [{
      id: 'ol1',
      text: 'Bir olaya ait olası durumları belirler.',
      completed: false
    }, {
      id: 'ol2',
      text: 'Eşit şansa sahip olan olası durumlardan bazılarının olma olasılığını hesaplar.',
      completed: false
    }]
  }, {
    title: 'Cebirsel İfadeler',
    achievements: [{
      id: 'ci1',
      text: 'Basit cebirsel ifadeleri anlar ve farklı biçimlerde yazar.',
      completed: false
    }, {
      id: 'ci2',
      text: 'Cebirsel ifadelerin çarpımını yapar.',
      completed: false
    }, {
      id: 'ci3',
      text: 'Özdeşlikleri modellerle açıklar.',
      completed: false
    }]
  }, {
    title: 'Doğrusal Denklemler ve Eğim',
    achievements: [{
      id: 'dd1',
      text: 'Doğrusal denklemlerin grafiğini çizer.',
      completed: false
    }, {
      id: 'dd2',
      text: 'Doğrusal denklemleri açıklar.',
      completed: false
    }, {
      id: 'dd3',
      text: 'Bir doğrunun eğimini modellerle açıklar, doğrusal denklemleri ve grafiklerini eğimle ilişkilendirir.',
      completed: false
    }]
  }, {
    title: 'Eşitsizlikler',
    achievements: [{
      id: 'es1',
      text: 'Birinci dereceden bir bilinmeyenli eşitsizlik içeren günlük hayat durumlarına uygun matematik cümleleri yazar.',
      completed: false
    }, {
      id: 'es2',
      text: 'Birinci dereceden bir bilinmeyenli eşitsizlikleri sayı doğrusunda gösterir.',
      completed: false
    }]
  }, {
    title: 'Üçgenler',
    achievements: [{
      id: 'uc1',
      text: 'Üçgenin iki kenar uzunluğunun toplamı veya farkı ile üçüncü kenarının uzunluğunu ilişkilendirir.',
      completed: false
    }, {
      id: 'uc2',
      text: 'Pisagor bağıntısını oluşturur ve kullanır.',
      completed: false
    }, {
      id: 'uc3',
      text: 'Üçgenin kenar uzunlukları ile bu kenarların karşısındaki açıların ölçülerini ilişkilendirir.',
      completed: false
    }]
  }, {
    title: 'Eşlik ve Benzerlik',
    achievements: [{
      id: 'eb1',
      text: 'Eş çokgenlerin kenar ve açı özelliklerini belirler.',
      completed: false
    }, {
      id: 'eb2',
      text: 'Benzer çokgenlerin kenar ve açı özelliklerini belirler.',
      completed: false
    }]
  }, {
    title: 'Dönüşüm Geometrisi',
    achievements: [{
      id: 'dg1',
      text: 'Nokta, doğru parçası ve diğer şekillerin öteleme altındaki görüntülerini oluşturur.',
      completed: false
    }, {
      id: 'dg2',
      text: 'Nokta, doğru parçası ve diğer şekillerin yansıma altında görüntülerini oluşturur.',
      completed: false
    }, {
      id: 'dg3',
      text: 'Çokgenlerin öteleme ve yansıma sonucunda ortaya çıkan görüntüsünü oluşturur.',
      completed: false
    }]
  }, {
    title: 'Geometrik Cisimler',
    achievements: [{
      id: 'gc1',
      text: 'Üç boyutlu cisimlerin görünümlerini farklı yönlerden çizer.',
      completed: false
    }, {
      id: 'gc2',
      text: 'Çok yüzlüleri sınıflandırır.',
      completed: false
    }, {
      id: 'gc3',
      text: 'Çizimleri verilen yapıları çok küplülerle oluşturur, çok küplülerle oluşturulan yapıların görünümlerini çizer.',
      completed: false
    }]
  }]
}, {
  id: 'fen',
  title: 'Fen Bilimleri',
  image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/342defcc-7c1d-494c-b44e-30031e1df94e/image_fx__(7).jpg',
  topics: [{
    title: 'Mevsimler ve İklim',
    achievements: [{
      id: 'mi1',
      text: 'Mevsimlerin Oluşumu',
      completed: false
    }, {
      id: 'mi2',
      text: 'İklim ve Hava Hareketleri',
      completed: false
    }]
  }, {
    title: 'DNA ve Genetik Kod',
    achievements: [{
      id: 'dg1',
      text: 'DNA ve Genetik Kod',
      completed: false
    }, {
      id: 'dg2',
      text: 'Kalıtım',
      completed: false
    }, {
      id: 'dg3',
      text: 'Mutasyon ve Modifikasyon',
      completed: false
    }, {
      id: 'dg4',
      text: 'Adaptasyon',
      completed: false
    }, {
      id: 'dg5',
      text: 'Biyoteknoloji',
      completed: false
    }]
  }, {
    title: 'Basınç',
    achievements: [{
      id: 'b1',
      text: 'Basınç kavramını ve etkilerini açıklar',
      completed: false
    }]
  }, {
    title: 'Madde ve Endüstri',
    achievements: [{
      id: 'me1',
      text: 'Periyodik Sistem',
      completed: false
    }, {
      id: 'me2',
      text: 'Fiziksel ve Kimyasal Değişimler',
      completed: false
    }, {
      id: 'me3',
      text: 'Kimyasal Tepkimeler',
      completed: false
    }, {
      id: 'me4',
      text: 'Asitler ve Bazlar',
      completed: false
    }, {
      id: 'me5',
      text: 'Maddenin Isı ile Etkileşimi',
      completed: false
    }, {
      id: 'me6',
      text: "Türkiye'de Kimya Endüstrisi",
      completed: false
    }]
  }, {
    title: 'Basit Makineler',
    achievements: [{
      id: 'bm1',
      text: 'Basit makinelerin çalışma prensiplerini açıklar',
      completed: false
    }]
  }, {
    title: 'Enerji Dönüşümleri ve Çevre Bilimi',
    achievements: [{
      id: 'ed1',
      text: 'Besin Zinciri ve Enerji Akışı',
      completed: false
    }, {
      id: 'ed2',
      text: 'Enerji Dönüşümleri',
      completed: false
    }, {
      id: 'ed3',
      text: 'Madde Döngüleri ve Çevre Sorunları',
      completed: false
    }, {
      id: 'ed4',
      text: 'Sürdürülebilir Kalkınma',
      completed: false
    }]
  }, {
    title: 'Elektrik Yükleri ve Elektrik Enerjisi',
    achievements: [{
      id: 'ey1',
      text: 'Elektrik Yükleri ve Elektriklenme',
      completed: false
    }, {
      id: 'ey2',
      text: 'Elektrik Yüklü Cisimler',
      completed: false
    }, {
      id: 'ey3',
      text: 'Elektrik Enerjisinin Dönüşümü',
      completed: false
    }]
  }]
}, {
  id: 'inkılap',
  title: 'T.C. İnkılap Tarihi ve Atatürkçülük',
  image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/8f55533b-a8d1-414d-95ae-dd4d9212be55/image_fx__(8).jpg',
  topics: [{
    title: 'Bir Kahraman Doğuyor',
    achievements: [{
      id: 'bkd1',
      text: "Mustafa Kemal'in çocukluk ve öğrenim hayatını kavrar",
      completed: false
    }]
  }, {
    title: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
    achievements: [{
      id: 'mu1',
      text: 'İşgallere karşı halkın direniş hareketlerini açıklar',
      completed: false
    }]
  }, {
    title: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
    achievements: [{
      id: 'mbd1',
      text: "Kurtuluş Savaşı'nın aşamalarını kavrar",
      completed: false
    }]
  }, {
    title: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
    achievements: [{
      id: 'act1',
      text: 'Atatürk ilkelerini ve inkılaplarını açıklar',
      completed: false
    }]
  }, {
    title: 'Demokratikleşme Çabaları',
    achievements: [{
      id: 'dc1',
      text: 'Çok partili hayata geçiş sürecini değerlendirir',
      completed: false
    }]
  }, {
    title: 'Atatürk Dönemi Dış Politika',
    achievements: [{
      id: 'addp1',
      text: 'Atatürk dönemi Türk dış politikasının temel ilkelerini kavrar',
      completed: false
    }]
  }, {
    title: "Atatürk'ün Ölümü ve Sonrası",
    achievements: [{
      id: 'aos1',
      text: "Atatürk sonrası Türkiye'nin gelişim sürecini analiz eder",
      completed: false
    }]
  }]
}, {
  id: 'ingilizce',
  title: 'İngilizce',
  image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/ea67535a-604d-4bf1-9bcd-1b4b904b3521/image_fx__(9).jpg',
  topics: [{
    title: 'Friendship',
    achievements: [{
      id: 'fr1',
      text: 'Friendship vocabulary and expressions',
      completed: false
    }]
  }, {
    title: 'Teen Life',
    achievements: [{
      id: 'tl1',
      text: 'Daily routines and activities',
      completed: false
    }]
  }, {
    title: 'In The Kitchen',
    achievements: [{
      id: 'itk1',
      text: 'Food vocabulary and cooking instructions',
      completed: false
    }]
  }, {
    title: 'On The Phone',
    achievements: [{
      id: 'otp1',
      text: 'Phone conversations and expressions',
      completed: false
    }]
  }, {
    title: 'The Internet',
    achievements: [{
      id: 'ti1',
      text: 'Internet vocabulary and online activities',
      completed: false
    }]
  }, {
    title: 'Adventures',
    achievements: [{
      id: 'adv1',
      text: 'Adventure stories and past tense',
      completed: false
    }]
  }, {
    title: 'Tourism',
    achievements: [{
      id: 'tour1',
      text: 'Travel vocabulary and giving directions',
      completed: false
    }]
  }, {
    title: 'Chores',
    achievements: [{
      id: 'ch1',
      text: 'Household chores and responsibilities',
      completed: false
    }]
  }, {
    title: 'Science',
    achievements: [{
      id: 'sci1',
      text: 'Scientific vocabulary and processes',
      completed: false
    }]
  }, {
    title: 'Natural Forces',
    achievements: [{
      id: 'nf1',
      text: 'Natural disasters and weather conditions',
      completed: false
    }]
  }]
}, {
  id: 'din',
  title: 'Din Kültürü ve Ahlâk Bilgisi',
  image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/a58167ac-e09a-4736-bf01-faa35ee6e6a7/image_fx__(10).jpg',
  topics: [{
    title: 'Kader İnancı',
    achievements: [{
      id: 'ki1',
      text: 'Kader ve kaza inancını açıklar',
      completed: false
    }]
  }, {
    title: 'Bir Peygamber Tanıyorum: Hz. Musa',
    achievements: [{
      id: 'bpt1',
      text: "Hz. Musa'nın hayatını ve mücadelesini kavrar",
      completed: false
    }]
  }, {
    title: 'Zekat ve Sadaka',
    achievements: [{
      id: 'zs1',
      text: 'Zekat ve sadakanın önemini ve toplumsal faydalarını açıklar',
      completed: false
    }]
  }, {
    title: 'Din ve Hayat',
    achievements: [{
      id: 'dh1',
      text: 'Dinin günlük hayattaki yerini ve önemini kavrar',
      completed: false
    }]
  }, {
    title: "Hz. Muhammed'in Örnekliği",
    achievements: [{
      id: 'hmo1',
      text: "Hz. Muhammed'in örnek davranışlarını günlük hayatla ilişkilendirir",
      completed: false
    }]
  }, {
    title: "Kur'an-ı Kerim ve Özellikleri",
    achievements: [{
      id: 'kko1',
      text: "Kur'an-ı Kerim'in temel özelliklerini açıklar",
      completed: false
    }]
  }, {
    title: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
    achievements: [{
      id: 'ipyo1',
      text: "İslam'da paylaşma ve yardımlaşmanın önemini kavrar",
      completed: false
    }]
  }, {
    title: 'İslam Dinine Göre Kötü Davranışlar',
    achievements: [{
      id: 'idkd1',
      text: "İslam'ın yasakladığı kötü davranışları ve bunların zararlarını açıklar",
      completed: false
    }]
  }, {
    title: 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)',
    achievements: [{
      id: 'ipyi1',
      text: 'Tevekkül kavramını ve insanın yardımlaşma ihtiyacını açıklar',
      completed: false
    }]
  }, {
    title: 'Hac ibadeti',
    achievements: [{
      id: 'hi1',
      text: 'Hac ibadetinin nasıl yapıldığını ve önemini kavrar',
      completed: false
    }]
  }]
}];
// Derslere göre border renkleri
const subjectBorderColors = {
  turkce: 'border-red-500',
  matematik: 'border-blue-500',
  fen: 'border-green-500',
  inkılap: 'border-amber-700',
  din: 'border-blue-900',
  ingilizce: 'border-purple-500'
};
export function TopicProgress() {
  const [selectedSubject, setSelectedSubject] = useState<Subject | null>(null);
  const [selectedTopic, setSelectedTopic] = useState<Topic | null>(null);
  const [completedAchievements, setCompletedAchievements] = useState<Set<string>>(new Set());
  const getSubjectGradient = (subjectId: string) => {
    return subjectColors[subjectId as keyof typeof subjectColors] || {
      from: 'from-purple-600',
      to: 'to-indigo-600'
    };
  };
  const toggleAchievement = (achievementId: string) => {
    setCompletedAchievements(prev => {
      const newSet = new Set(prev);
      if (newSet.has(achievementId)) {
        newSet.delete(achievementId);
      } else {
        newSet.add(achievementId);
      }
      return newSet;
    });
  };
  if (selectedTopic) {
    const gradient = getSubjectGradient(selectedSubject?.id || '');
    const borderColor = subjectBorderColors[selectedSubject?.id as keyof typeof subjectBorderColors] || 'border-purple-600';
    return <div className="space-y-6" data-id="element-3305">
        <div className="flex items-center gap-4" data-id="element-3306">
          <button onClick={() => setSelectedTopic(null)} className={`flex items-center gap-2 px-4 py-2 rounded-lg border bg-gradient-to-r ${gradient.from} ${gradient.to} text-white hover:opacity-90 transition-all`} data-id="element-3307">
            <ArrowLeft className="w-5 h-5" data-id="element-3308" />
            Geri
          </button>
          <h1 className="text-2xl font-bold" data-id="element-3309">{selectedTopic.title}</h1>
        </div>
        <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600" data-id="element-3310">
          <div className="relative p-6 bg-black/90 rounded-lg" data-id="element-3311">
            <div className="space-y-4" data-id="element-3312">
              {selectedTopic.achievements.map(achievement => <button key={achievement.id} onClick={() => toggleAchievement(achievement.id)} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg bg-black/90 hover:bg-black/80 transition-colors text-left border ${borderColor}`} data-id="element-3313">
                  {completedAchievements.has(achievement.id) ? <CheckCircle className="w-5 h-5 text-green-400 shrink-0" data-id="element-3314" /> : <Circle className="w-5 h-5 text-gray-400 shrink-0" data-id="element-3315" />}
                  <span className="text-sm text-gray-300" data-id="element-3316">
                    {achievement.text}
                  </span>
                </button>)}
            </div>
          </div>
        </div>
      </div>;
  }
  if (selectedSubject) {
    const gradient = getSubjectGradient(selectedSubject.id);
    return <div className="space-y-6" data-id="element-3317">
        <div className="flex items-center gap-4" data-id="element-3318">
          <button onClick={() => setSelectedSubject(null)} className={`flex items-center gap-2 px-4 py-2 rounded-lg border bg-gradient-to-r ${gradient.from} ${gradient.to} text-white hover:opacity-90 transition-all`} data-id="element-3319">
            <ArrowLeft className="w-5 h-5" data-id="element-3320" />
            Geri
          </button>
          <h1 className="text-2xl font-bold" data-id="element-3321">{selectedSubject.title}</h1>
        </div>
        <div className="space-y-4" data-id="element-3322">
          {selectedSubject.topics.map((topic, index) => <div key={index} onClick={() => setSelectedTopic(topic)} className={`relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r ${gradient.from} ${gradient.to} cursor-pointer group hover:shadow-[0_0_10px_rgba(255,255,255,0.2)] transition-all duration-300`} data-id="element-3323">
              <div className="relative p-6 bg-black/90 rounded-lg" data-id="element-3324">
                <div className="flex items-center justify-between" data-id="element-3325">
                  <h3 className="text-lg font-medium group-hover:text-white transition-colors" data-id="element-3326">
                    {topic.title}
                  </h3>
                  <div className="flex items-center gap-2" data-id="element-3327">
                    <span className="text-sm text-gray-400" data-id="element-3328">
                      {topic.achievements.filter(a => completedAchievements.has(a.id)).length}{' '}
                      / {topic.achievements.length}
                    </span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>;
  }
  return <div className="space-y-6" data-id="element-3329">
      <h1 className="text-2xl font-bold" data-id="element-3330">Konu Takip Çizelgesi</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3331">
        {subjects.map(subject => {
        const gradient = getSubjectGradient(subject.id);
        return <div key={subject.id} className={`relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r ${gradient.from} ${gradient.to} group cursor-pointer`} onClick={() => setSelectedSubject(subject)} data-id="element-3332">
              <div className="relative bg-black/90 rounded-lg h-full" data-id="element-3333">
                <div className="relative aspect-[16/9]" data-id="element-3334">
                  <img src={subject.image} alt={subject.title} className="absolute inset-0 w-full h-full object-cover" data-id="element-3335" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 to-transparent" data-id="element-3336" />
                  <div className="absolute inset-0 flex items-end justify-center p-8" data-id="element-3337">
                    <h3 className="text-xl font-semibold text-center" data-id="element-3338">
                      {subject.title}
                    </h3>
                  </div>
                </div>
              </div>
            </div>;
      })}
      </div>
    </div>;
}